import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/NEWLogin.vue";
import actions from "@/store/shardActions";
import { isEmpty, removeOtherLocalStoreage } from "../utils/utils";
import { Notification } from "element-ui";
import i18n from "../i18n";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "*",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/forceBind",
    name: "ForceBind",
    component: () => import("../views/ForceBind.vue"),
  },
  {
    path: "/googleLogin",
    name: "GoogleLogin",
    component: () => import("../views/GoogleLogin.vue"),
  },
  {
    path: "/otherSystemLogin",
    name: "otherSystemLogin",
    component: () => import("../views/OtherSystemLogin.vue"),
  },
  {
    path: "/forcePwdChange",
    name: "forcePwdChange",
    component: () => import("../views/ForcePasswordChange"),
  },
  {
    path: "/soc/:type/:loginType",
    name: "Soc",
    component: () => import("../views/socFile/index.vue"),
  },
  {
    path: "/redirect",
    name: "redirect",
    component: () => import("../views/RedirectPage.vue"),
  },
  {
    path: "/activeUser",
    name: "activeUser",
    component: () => import("../views/FindPassword.vue"),
    meta:{
      pageType:'activeUser'
    }
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () => import("../views/ForgetPassword.vue"),
  },
  {
    path: "/findPassword",
    name: "findPassword",
    component: () => import("../views/FindPassword.vue"),
    meta:{
      pageType:'findPassword'
    }
  },
];
const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    next();
  } else {
    let token = actions.getGlobalState("accessToken");
    // 这玩应存在 代表密码有问题，得强制修改
    let pwdFlag = localStorage.getItem("as-pwdFlag")
      ? JSON.parse(localStorage.getItem("as-pwdFlag"))
      : {};
    if (token && token.length > 0) {
      if (isEmpty(pwdFlag)) {
        if (to.name == "Login") {
          next({ name: "Home" });
        } else if (to.name == "ForceBind") {
          if (to.params.username && to.params.username.length > 0) {
            next();
          } else {
            actions.setGlobalState({
              accessToken: "",
              //commonData修改
              dataUpdate: false,
              // 当前用户信息
              currentUser: "",
              // 当前用户权限树
              permissionTree: "",
              // 获取token报错
              getTokenError: false,
              //当前客户
              currentCustomer: "",
              //当前门店
              currentStore: "",
              //控制菜单  隐藏显示
              showMenu: true,
              // 公共客户门店数据
              commonData: {},
              currentAppName: "",
            });
            removeOtherLocalStoreage();
            next({ name: "Login" });
          }
        } else {
          next();
        }
      } else {
        // 进home拦截 ， 不可进入系统中
        if (to.name == "Home") {
          Notification.warning(i18n.t("loginPromptMessage.forcePwdModify"));
          next({ name: "forcePwdChange" });
        } else if (to.name == "forcePwdChange") {
          next();
        } else if (to.name == "GoogleLogin") {
          next();
        } else if (to.name == "Login") {
          // 密码有问题 ，去到了登录页面
          actions.setGlobalState({
            accessToken: "",
            //commonData修改
            dataUpdate: false,
            // 当前用户信息
            currentUser: "",
            // 当前用户权限树
            permissionTree: "",
            // 获取token报错
            getTokenError: false,
            //当前客户
            currentCustomer: "",
            //当前门店
            currentStore: "",
            //控制菜单  隐藏显示
            showMenu: true,
            // 公共客户门店数据
            commonData: {},
            currentAppName: "",
          });
          removeOtherLocalStoreage();
          localStorage.removeItem("accessToken");
          localStorage.removeItem("as-servicePage");
          next();
        } else {
          if (from.name == "forcePwdChange" && to.name == "GoogleLogin") {
            Notification.warning(i18n.t("loginPromptMessage.relogin"));
          }
          actions.setGlobalState({
            accessToken: "",
            //commonData修改
            dataUpdate: false,
            // 当前用户信息
            currentUser: "",
            // 当前用户权限树
            permissionTree: "",
            // 获取token报错
            getTokenError: false,
            //当前客户
            currentCustomer: "",
            //当前门店
            currentStore: "",
            //控制菜单  隐藏显示
            showMenu: true,
            // 公共客户门店数据
            commonData: {},
            currentAppName: "",
          });
          removeOtherLocalStoreage();
          next({ name: "Login" });
        }
      }
    } else {
      if (to.name == "Login"||to.name=="redirect") {
        next();
      } else if (to.name == "otherSystemLogin") {
        next();
      } else if (to.name == "Soc" || to.name == 'activeUser' || to.name=='forgetPassword' || to.name=='findPassword') {
        next();
      } else {
        removeOtherLocalStoreage();
        next({ name: "Login" });
      }
    }
  }
});

export default router;
